<template>
  <form
    class="border-1 border-background-fg/8 flex flex-wrap items-center justify-between rounded p-2"
    @submit="onSubmit"
  >
    <FormInputPercentage
      name="defaultServiceChargePercentage"
      label="Default Percentage Service Charge"
      :min="0"
    />
    <FormInputPrice
      name="defaultServiceChargeFlat"
      label="Default Flat Service Charge"
      :min="0"
    />
    <FormSubmitButton> Save </FormSubmitButton>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import z from "zod"
import { toTypedSchema } from "@vee-validate/zod"

type ServiceChargeForm = {
  defaultServiceChargeFlat: number
  defaultServiceChargePercentage: number
}
const props = defineProps<{
  initialValues: ServiceChargeForm
}>()
const emit = defineEmits<{
  (event: "submit", params: ServiceChargeForm): void
}>()
const serviceChargeFormSchema = z.object({
  defaultServiceChargePercentage: z
    .number()
    .min(0)
    .max(100),
  defaultServiceChargeFlat: z.number().min(0),
})
const { handleSubmit, setValues } = useForm({
  validationSchema: toTypedSchema(serviceChargeFormSchema),
  initialValues: {
    defaultServiceChargePercentage: 0,
    defaultServiceChargeFlat: 0,
  },
})

watch(
  () => props.initialValues,
  (values) => {
    setValues(values)
  },
  {
    deep: true,
    immediate: true,
  }
)

const onSubmit = handleSubmit((params) => {
  emit("submit", params)
})
</script>
